<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">一键拨号管理</h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.dialing_name" placeholder="请输入拨号名称" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="success" size="large" @click="openAddDialog" style="float: right">
          <el-icon>
            <Plus />
          </el-icon>
          新增拨号
        </el-button>
      </div>

      <!-- 拨号列表 -->
      <el-table :data="dialingList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column prop="dialing_name" label="拨号名称" width="180" />
        <el-table-column prop="dialing_type" label="拨号位置" width="120">
          <template #default="{ row }">
            <el-tag :type="row.dialing_type === 1 ? 'primary' : 'success'">
              {{ row.dialing_type === 1 ? '顶部拨号' : '底部拨号' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="dialing_phone" label="电话号码" width="180" />
        <el-table-column prop="dialing_text" label="显示文字" width="150" />
        <el-table-column prop="notes" label="备注" width="150" />
        <el-table-column prop="create_time" label="创建时间" width="180" />
        <el-table-column prop="update_time" label="更新时间" width="180" />

        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
              <el-icon>
                <Edit />
              </el-icon>
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
              <el-icon>
                <Delete />
              </el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchDialingList" @current-change="fetchDialingList" />
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">
      <el-form ref="dialingForm" :model="dialingForm" label-width="120px" :rules="formRules">
        <el-form-item label="拨号名称" prop="dialing_name">
          <el-input v-model="dialingForm.dialing_name" placeholder="请输入拨号名称" size="large" />
        </el-form-item>

        <el-form-item label="拨号位置" prop="dialing_type">
          <el-radio-group v-model="dialingForm.dialing_type">
            <el-radio :label="1">顶部拨号</el-radio>
            <el-radio :label="2">底部拨号</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="电话号码" prop="dialing_phone">
          <el-input v-model="dialingForm.dialing_phone" placeholder="请输入电话号码" size="large" />
        </el-form-item>

        <el-form-item label="显示文字" prop="dialing_text">
          <el-input v-model="dialingForm.dialing_text" placeholder="请输入显示文字" size="large" />
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input v-model="dialingForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitDialingForm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Plus, Edit, Delete
} from '@element-plus/icons-vue'

export default {
  name: 'MaterialCall',
  components: { Search, Plus, Edit, Delete },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增拨号',
      isEditMode: false,
      searchForm: {
        dialing_name: ''
      },
      dialingForm: {
        id: null,
        dialing_type: 1,
        dialing_name: '',
        dialing_phone: '',
        dialing_text: '',
        notes: ''
      },
      formRules: {
        dialing_name: [
          { required: true, message: '请输入拨号名称', trigger: 'blur' }
        ],
        dialing_type: [
          { required: true, message: '请选择拨号位置', trigger: 'change' }
        ],
        dialing_phone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' }
        ],
        dialing_text: [
          { required: true, message: '请输入显示文字', trigger: 'blur' }
        ]
      },
      dialingList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  mounted() {
    this.fetchDialingList();
  },
  methods: {
    // 获取拨号列表
    async fetchDialingList() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.dialing_name ? 'search' : 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        // 如果有搜索条件，加入搜索参数
        if (this.searchForm.dialing_name) {
          params.dialing_name = this.searchForm.dialing_name;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/one_touch_dialing.php`,
          params
        );

        if (data.data) {
          this.dialingList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取拨号列表失败');
        console.error('获取拨号列表错误:', error);
      } finally {
        this.loading = false;
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchDialingList();
    },

    // 打开新增对话框
    openAddDialog() {
      this.dialogTitle = '新增拨号';
      this.isEditMode = false;
      this.dialingForm = {
        id: null,
        dialing_type: 1,
        dialing_name: '',
        dialing_phone: '',
        dialing_text: '点击文字联系我们↓↓↓↓↓',
        notes: ''
      };
      this.dialogVisible = true;
    },

    // 打开编辑对话框
    openEditDialog(row) {
      this.dialogTitle = '编辑拨号';
      this.isEditMode = true;
      this.dialingForm = {
        id: row.id,
        dialing_type: row.dialing_type,
        dialing_name: row.dialing_name,
        dialing_phone: row.dialing_phone,
        dialing_text: row.dialing_text,
        notes: row.notes
      };
      this.dialogVisible = true;
    },

    // 提交表单（新增/编辑）
    submitDialingForm() {
      this.$refs.dialingForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add';
            const payload = {
              ...this.dialingForm,
              store_id: this.userInfo.id
            };

            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/one_touch_dialing.php`,
              {
                action,
                ...payload
              }
            );

            if (data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchDialingList();
            } else {
              this.$message.error(data.error || '操作失败');
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '操作失败';
            this.$message.error(`操作失败: ${errorMsg}`);
            console.error('表单提交错误:', error);
          }
        }
      });
    },

    // 删除拨号
    async handleDelete(id) {
      this.$confirm('确定要删除该拨号配置吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/one_touch_dialing.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.id
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchDialingList();
          } else {
            this.$message.error(data.error || '删除失败');
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '删除失败';
          this.$message.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles/page-common.scss' as *;
</style>